// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ho-3";
export var downloadButton = "_ho-4";
export var fileContainer = "_ho-9 _ho-7";
export var fileContainerBase = "_ho-7";
export var fileContainerFixedHeight = "_ho-8 _ho-7";
export var fileInfo = "_ho-5";
export var fileInfoWidthRestricted = "_ho-6";
export var fileType = "_ho-1";
export var fileTypeName = "_ho-2";
export var image = "_ho-0";
export var link = "_ho-b";
export var overflowEllipsis = "_ho-a";